import { Box } from '@mui/material'
import { useTheme } from '@mui/styles'
import AppContext from 'app/appContext'
import Layout1Sidenav from 'app/EgretLayout/Layout1/Layout1Sidenav'
import { SidenavToggleBtn } from 'app/EgretLayout/Layout1/SidenavToggleBtn'
import { useSidebarMode } from 'app/EgretLayout/Layout1/useSidebarMode'
import PortalTranslationWarningBar from 'app/EgretLayout/PortalTranslationWarningBar'
import { FirstLoginFlowNavLayer } from 'app/views/first-login-flow/firstLoginFlowNavLayer'
import { useRef } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'
import { useSelector } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { classList } from 'utils'
import Topbar from './Topbar'
import { usePreviousRoute } from './usePreviousRoute'

const AppLayout = () => {
  const ref = useRef()
  const settings = useSelector(state => state.layout.settings)
  const { layout1Settings } = settings
  const theme = useTheme()
  const language = useSelector(state => state.user.language)

  const layoutClasses = {
    // [classes.layout]: true,
    [`${settings.activeLayout} sidenav-${layout1Settings.leftSidebar.mode} theme-${theme.palette.mode} flex`]: true
    // 'topbar-fixed': layout1Settings.topbar.fixed
  }

  const sidenavToggleRef = useRef(null)
  const layoutSidenavRef = useRef(null)
  const isToggleBtnTouchedRef = useRef(false)
  const contentWrapRef = useRef(null)
  const { mode, updateSidebarMode, allowClosing } = useSidebarMode()
  const previous = usePreviousRoute()

  return (
    <AppContext.Consumer>
      {(appContext) => {
        const contextValue = {
          ...appContext,
          previousPath: previous.path,
          previousName: previous.name
        }

        return (
          <AppContext.Provider value={contextValue}>
            <FirstLoginFlowNavLayer routes={appContext.routes} ref={ref}>
              <div className={`${classList(layoutClasses)} flex`}>
                <Layout1Sidenav
                  layoutSidenavRef={layoutSidenavRef}
                  isToggleBtnTouchedRef={isToggleBtnTouchedRef}
                  contentWrapRef={contentWrapRef}
                  mode={mode}
                />

                <Box
                  className='content-wrap position-relative'
                  ref={contentWrapRef}
                  sx={{ borderLeft: '1px solid #c0c0c0' }}
                >
                  <Topbar />
                  <Scrollbars
                    className='scrollable-content'
                    ref={ref}
                    style={{ backgroundColor: theme.palette.background.main }}
                  >
                    <PortalTranslationWarningBar />
                    {renderRoutes(appContext.routes, {
                      scrollbarContentRef: ref,
                      previousPath: previous.path,
                      previousName: previous.name
                    })}
                    <div className='my-auto' />
                  </Scrollbars>
                  <SidenavToggleBtn
                    sidenavToggleRef={sidenavToggleRef}
                    layoutSidenavRef={layoutSidenavRef}
                    isToggleBtnTouchedRef={isToggleBtnTouchedRef}
                    mode={mode}
                    updateSidebarMode={updateSidebarMode}
                    allowClosing={allowClosing}
                  />
                </Box>
              </div>
            </FirstLoginFlowNavLayer>
          </AppContext.Provider>
        )
      }}
    </AppContext.Consumer>
  )
}

export default AppLayout
